'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _blocks = require('../../blocks');

var _ActionButton = require('./ActionButton');

var _ActionButton2 = _interopRequireDefault(_ActionButton);

var _Avatar = require('./Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _TextField = require('./TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _TextArea = require('./TextArea');

var _TextArea2 = _interopRequireDefault(_TextArea);

var _CharsLeftLabel = require('./CharsLeftLabel');

var _CharsLeftLabel2 = _interopRequireDefault(_CharsLeftLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BC_INPUT_FIELD_CONTEXT = '__BC_INPUT_FIELD_CONTEXT__';

function withInputFieldProps(WrappedComponent) {
  function WithInputFieldProps(props, context) {
    var propsFromInputField = context[BC_INPUT_FIELD_CONTEXT] || {};
    return _react2.default.createElement(WrappedComponent, _extends({}, propsFromInputField, props, {
      value: propsFromInputField.readOnly && !propsFromInputField.value && !props.value ? props.readOnlyEmptyValue || '—' : propsFromInputField.value
    }));
  }

  WithInputFieldProps.propTypes = {
    readOnlyEmptyValue: _propTypes2.default.string,
    value: _propTypes2.default.string
  };

  WithInputFieldProps.defaultProps = {
    readOnlyEmptyValue: undefined,
    value: undefined
  };

  WithInputFieldProps.contextTypes = _defineProperty({}, BC_INPUT_FIELD_CONTEXT, _propTypes2.default.shape({
    disabled: _propTypes2.default.bool.isRequired,
    onBlur: _propTypes2.default.func.isRequired,
    onFocus: _propTypes2.default.func.isRequired,
    placeholder: _propTypes2.default.string.isRequired,
    readOnly: _propTypes2.default.bool.isRequired,
    value: _propTypes2.default.string.isRequired
  }).isRequired);

  return WithInputFieldProps;
}

var InputField = function (_Component) {
  _inherits(InputField, _Component);

  function InputField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputField.__proto__ || Object.getPrototypeOf(InputField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFocused: false
    }, _this.handleBlur = function (e) {
      !_this.props.readOnly && _this.props.onBlur(e);
      _this.setState(function () {
        return { isFocused: false };
      });
    }, _this.handleFocus = function (e) {
      _this.props.onFocus(e);
      _this.setState(function () {
        return { isFocused: true };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // Wrap any component needing the input field's props in withInputFieldProps


  _createClass(InputField, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return _defineProperty({}, BC_INPUT_FIELD_CONTEXT, _extends({}, (0, _lodash.omit)(this.props, ['children']), {
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var isFocused = this.state.isFocused;
      var _props = this.props,
          children = _props.children,
          disabled = _props.disabled,
          isValid = _props.isValid,
          modifiers = _props.modifiers,
          readOnly = _props.readOnly;


      var borderFocus = isFocused && 'focused';
      var borderWarning = !isValid && 'borderWarning';
      var disabledInput = disabled && 'disabled';
      var readOnlyInput = readOnly && 'readOnly';
      var inputModifiers = (0, _lodash.compact)([borderFocus, borderWarning, disabledInput, readOnlyInput, 'fluid'].concat(_toConsumableArray(modifiers)));

      var rowModifiers = ['height_100',
      // If set to grow in height (i.e. TextAreas), we want
      // the columns to align their content to the top.
      !modifiers.includes('height_auto') && 'middle'];

      return _react2.default.createElement(
        _blocks.Input,
        { modifiers: inputModifiers, readOnly: readOnly },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          { modifiers: (0, _lodash.compact)(rowModifiers) },
          children
        )
      );
    }
  }]);

  return InputField;
}(_react.Component);

InputField.Avatar = _Avatar2.default;
InputField.Icon = _Icon2.default;
InputField.Label = _Label2.default;
InputField.Text = _Text2.default;
InputField.ActionButton = withInputFieldProps(_ActionButton2.default);
InputField.TextField = withInputFieldProps(_TextField2.default);
InputField.TextArea = withInputFieldProps(_TextArea2.default);
InputField.CharsLeftLabel = withInputFieldProps(_CharsLeftLabel2.default);
InputField.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  isValid: _propTypes2.default.bool,
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string),
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  // eslint-disable-next-line react/no-unused-prop-types
  placeholder: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool
};
InputField.defaultProps = {
  disabled: false,
  isValid: true,
  modifiers: [],
  onBlur: _lodash.noop,
  onFocus: _lodash.noop,
  placeholder: 'Enter Value...',
  readOnly: false
};
InputField.childContextTypes = _defineProperty({}, BC_INPUT_FIELD_CONTEXT, _propTypes2.default.object.isRequired);
exports.default = InputField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/InputField/index.js
// module id = 1656
// module chunks = 2